<div class="login-screen" id="myCheck">
  <div class="login-wrapper">
    <form [formGroup]="passwordForm" (ngSubmit)="sendNewPassword()">
      <div class="row">
        <div [ngClass]="(site === 'lilate') ? 'login-logo-lilate' : 'login-logo'"></div>
      </div>
      <p *ngIf="(site === 'lilate')" translate>resetpassword.lilate.text</p>
      <div class="flex-input">
        <input #inputPassword1
          placeholder="{{site === 'lilate' ? ('lilate.resetpassword.Saisissez votre nouveau mot de passe' | translate) : ('resetpassword.Saisissez votre nouveau mot de passe' | translate)  }}"
          type="password" [formControl]="password1" />
        <mat-icon
          (click)="inputPassword1.type === 'password' ? inputPassword1.type = 'text' : inputPassword1.type = 'password'"
          matSuffix>visibility</mat-icon>
      </div>

      <div class="form-control-feedback" *ngIf="password1.errors && (password1.dirty || password1.touched)">
        <p *ngIf="password1.errors.required" translate>resetpassword.Un mot de passe est requis</p>
        <p *ngIf="password1.errors.minlength" translate>resetpassword.minlength</p>
      </div>
      <div class="flex-input">

        <input #inputPassword2
          placeholder="{{site === 'lilate' ? ('lilate.resetpassword.Confirmez votre nouveau mot de passe' | translate) : ('resetpassword.Confirmez votre nouveau mot de passe' | translate) }}"
          type="password" [formControl]="password2" />
        <mat-icon
          (click)="inputPassword2.type === 'password' ? inputPassword2.type = 'text' : inputPassword2.type = 'password'"
          matSuffix>visibility</mat-icon>
      </div>
       <!-- <div class="input-icon">
          <input matInput
            placeholder="{{site === 'lilate' ? ('lilate.resetpassword.Confirmez votre nouveau mot de passe' | translate) : ('resetpassword.Confirmez votre nouveau mot de passe' | translate) }}"
            type="password" [formControl]="password2" />
          <mat-icon>visibility</mat-icon>
      </div> -->
      <div class="form-control-feedback" *ngIf="password2.errors && (password2.dirty || password2.touched)">
        <p *ngIf="password2.errors.required" translate>resetpassword.Un mot de passe est requis</p>
        <p *ngIf="password2.errors.minlength" translate>resetpassword.minlength</p>
        <p *ngIf="passwordForm.controls.password2.errors?.MatchPassword" translate>resetpassword.samepassword</p>

      </div>

      <button [ngClass]="(site === 'lilate') ? 'login-btn-lilate' : 'login-btn'" type="submit"
        [disabled]="!passwordForm.valid || !formChanges || loading" translate>resetpassword.Valider</button>

      <div *ngIf="loading" translate>
        <mat-spinner></mat-spinner>
      </div>
    </form>
  </div>
</div>